/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_New_Font_Name_LabelInputs */



/**
* | output |
* | --- |
* | "New font name" |
*
* @param {Options_Fonts_New_Font_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_new_font_name_label = /** @type {((inputs?: Options_Fonts_New_Font_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_New_Font_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de la nouvelle police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Schriftartname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo nome del font")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новое название шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo nombre de fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新字体名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいフォント名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए फ़ॉन्ट का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo nome de fonte")
	return /** @type {LocalizedString} */ ("New font name")
});